import { DefaultTheme } from "styled-components";

const theme: DefaultTheme = {
  colors: {
    primary: "#E5D2C4",
    secondary: "#c24040",
    tertiary: "#000000",
    fourth: "#FFEFEF",
    labelButton: "#FFFFFF",
    iconSearch: "#FFFFFF",
  },
  breakpoints: {
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
    xxl: "1400px",
  },
  width: {
    widthMain: "1400px",
  },
  fonts: {
    fontSizeGlobal: "62.5%",
    fontSizelogoTitle: "3rem",
    fontSizelogoSubtitle: "1rem",
  },
};

export default theme;
